import { httpClient, unwrap } from './httpClient';

export async function getDashboardSummary() {
  const response = await httpClient.get('/admin/summary/');
  return unwrap(response);
}

const adminSummaryService = {
  getDashboardSummary,
};

export default adminSummaryService;
